function tabs() {
    if (document.querySelector('.tabs')) {
        const tabsTitles = document.querySelectorAll('.tabs .tabs__title');
        const tabsContent = document.querySelectorAll('.tabs .tabs__content');
        

        tabsTitles.forEach((title, i) => {

            title.addEventListener('click', () => {
                
                tabsContent.forEach(content => {
                    // content.style.display = 'none';
                    content.classList.remove('tabs__content--active');
                });

                tabsTitles.forEach(title => {
                    title.classList.remove('tabs__title--active');
                });

                // tabsContent[i].style.display = 'block';
                tabsContent[i].classList.add('tabs__content--active');
                title.classList.add('tabs__title--active');
            });

        });
    }
}

module.exports = tabs;